import axiosInstance from "@/services/https/global";
import axios from "axios";
import CONFIG from "@/config";

const authUrl = `${CONFIG.API_BASE_URL}/auth-service/api/v1`;

export const sendWayaOfficialOtp = async () => {
  try {
    const response = await axiosInstance.get(
      `${authUrl}/admin/wayaquick-official/otp-send`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const verifyWayaOfficialOtp = async (otp) => {
  try {
    const response = await axiosInstance.post(
      `${authUrl}/admin/wayaquick-official/otp-verify/${otp}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};